<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productname"
					placeholder="请输入商品名称"
					class="name-input"
					size="small"
					@keyup.enter.native="tableReload"
				></el-input>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="select-box" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id" :disabled="item.disabledflag"/>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="select-box" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id" :disabled="item.disabledflag"></el-option>
					</template>
				</el-select>
			</div>
			<div>
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					plain
					@click="tableReload">查询</el-button>
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					v-if="!showCheckFlag"
					plain
					@click="showCheck(true)">查看选中商品</el-button>
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					v-if="showCheckFlag"
					plain
					@click="showCheck(false)">查看全部商品</el-button>
			</div>
		</div>
		<div class="table-box">
			<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="tableData"
				ref='table'
				:height="tableHeight"
				border
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="productname"
					label="商品名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="spec"
					label="规格"
					align="center"
					min-width="180">
					<!-- <template slot-scope="scope">
						<el-select v-model="scope.row.unitId" class="select-box" size='small' @change="clickchange">
							<el-option :value="item.attrplanid" :label="item.spec" v-for="item in scope.row.goodunit" :key="item.attrplanid"></el-option>
						</el-select>
					</template> -->
				</el-table-column>
				<el-table-column
					prop="code"
					label="商品编号"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="bcname"
					label="店铺级大类"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					v-if="bigcategoryview === 1"
					prop="sbname"
					label="店铺级小类"
					align="center"
					min-width="180">
				</el-table-column>
			</el-table>
		</div>
		<div class="page-box">
			<el-pagination
				v-if="!showCheckFlag"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20,40, 60, 100]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
		<div class="binding-foot">
			<el-button class="btn" plain type="primary" @click="cancelClick">取消</el-button>
			<el-button class="btn" plain type="primary" @click="saveClick">保 存</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'addGoods',
	props: {
		visible: Boolean,
		regularpurchaseProductListId: String
	},
	data () {
		return {
			allCheck: [],
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'attrplanid'
			}),
			bc: [],
			sc: [],
			shopId: '',
			bcId: '0',
			scId: '0',
			unitId: '',
			tableHeight: '100%',
			productname: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			// selectArr: [],
			bigcategoryview: 0,
			showCheckFlag: false
		}
	},
	computed: {
		selectArr () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	created () {
		this.getList()
		this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		})
	},
	methods: {
		showCheck (flag) {
			this.showCheckFlag = flag
			this.page = {
				number: 1,
				size: 20
			}
			if (flag) {
				this.allCheck = this.tableSelectUtils.getSelectRows()
				this.searchTable()
			} else {
				this.getList()
			}
			this.$refs.table.doLayout()
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getList () {
			let params = {
				regularpurchaseListId: this.regularpurchaseProductListId,
				bcId: this.bcId,
				scId: this.scId,
				productname: this.productname,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/regularPurchase/product/list`,
				data: params
			}).then(res => {
				if (res.result) {
					if (!res.data.recordList || res.data.recordList.length < 1) {
						this.tableData = []
						this.total = 0
						return false
					}
					if (res.data.recordList.length > 0) {
						let tableData = res.data.recordList
						this.tableData = tableData
						this.total = res.data.recordCount
						this.$nextTick(() => {
							this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
						})
					}
				}
			})
		},
		searchTable () {
			let bcId = this.bcId
			let scId = this.scId
			let productname = this.productname
			let arr = []
			this.allCheck.forEach(item => {
				let flag = true
				if (bcId !== '0') {
					if (item.bigCategoryId !== bcId) {
						flag = flag && false
					}
				}
				if (scId !== '0') {
					if (item.smallCategoryId !== scId) {
						flag = flag && false
					}
				}
				if (productname !== '') {
					if (item.productname.indexOf(productname) === -1) {
						flag = flag && false
					}
				}
				if (flag) {
					arr.push(item)
				}
			})
			this.tableData = arr
			this.$nextTick(() => {
				this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
			})
		},
		tableReload () {
			if (this.showCheckFlag) {
				this.searchTable()
			} else {
				this.getList()
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			if (this.showCheckFlag) {
				this.allCheck = this.tableSelectUtils.getSelectRows()
				this.searchTable()
			}
		},
		cancelClick () {
			this.$emit('closeDialog')
		},
		saveClick () {
			let selectArr = []
			this.selectArr.forEach(item => {
				selectArr.push({
					productId: item.productid,
					itemQuantity: 0,
					attrplanid: item.attrplanid,
					pname: item.productname,
					mustbuyflag: 0
				})
			})
			let params = {
				editCartInfos: selectArr
			}
			if (selectArr.length === 0) {
				this.$message.error('请选择商品')
				return false
			}
			this.$emit('saveEvent', params)
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>
.binding-body{
	display: flex;
	width :1150px;
	flex-direction: column;
	height :400px;
	overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :220px;
			margin-bottom:10px
			.name-input {
				width: 140px;
				margin-right: 10px;
			}
			.select-box{
				width:120px;
				margin-right:10px;
			}
		}
	}
	.table-box{
		width :100%;
		flex:1;
		// display: flex;
		// flex-direction: column;
	}
	.page-box{
		height: 40px;
		text-align :center;
		margin-top: 10px;
	}
	.btn-box{
		width :90%;
		padding :10px;
		text-align :left
	}
	.binding-foot{
		position: relative;
		height :40px;
		margin-top:10px;
		margin-bottom :10px;
		width :100%
		.btn{
			width :35%;
			margin-left:95px;
		}
	}
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
